export enum ITEM_TYPES {
  SERVICE_BOOKING_MEMBERSHIP = 'SERVICE_BOOKING_MEMBERSHIP',
  SERVICE_BOOKING_APPOINTMENT = 'SERVICE_BOOKING_APPOINTMENT',
  SERVICE_BOOKING_CLASS = 'SERVICE_BOOKING_CLASS',
  ORDER_AHEAD_ITEM = 'ORDER_AHEAD_ITEM',
  EVENT = 'EVENT',
}
